module.exports = __webpack_public_path__ + "c488ecae68ddf5574c36b7e5782f6954.svg";